import { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import _ from 'lodash';
import LocationModal from '../Overview/League/modals/LocationModal/LocationModal';
import TimeModal from '../Overview/League/modals/TimeModal/TimeModal';
import DaysModal from '../Overview/League/modals/DaysModal/DaysModal';
import DivisionName from '../Overview/League/modals/DivisionName/DivisionName';
import { days_played } from '../../../../../Util/helper';
import { messages } from '../../../../../messages';
import moment from 'moment';

export default function LeagueLocationScheduleSection(props) {
  const [daysPlayed, setDaysPlayed] = useState([]);
  const [locationsAndFields, setLocationsAndFields] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [type, setType] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [open, setOpen] = useState(false);
  const [leagueDivision, setDivision] = useState([]);
  useEffect(() => {
    if (props.data) {
      if (Array.isArray(props.data.days_played)) {
        setDaysPlayed(props.data.days_played);
        emit({ data: props.data.days_played, type: 'days_played' });
      }
      if (Array.isArray(props.data.league_locations)) {
        const loc_fields = props.data.league_locations.reduce((prev, curr) => {
          prev.push({
            location: curr.location,
            fields: curr.fields.map(field => field.locations_and_field)
          });
          return prev;
        }, []);
        setLocationsAndFields(loc_fields);
        emit({ data: loc_fields, type: 'location' });
      }
      if (props.data.time_slots) {
        const timeSlots = (props.data.time_slots || '').toString().trim().split(',');
        timeSlots.forEach((time, idx) => {
          timeSlots[idx] = moment(time, 'hh:mm A').format('hh:mm A');
        });
        setTimeSlots( timeSlots.sort((a, b) => moment(a, 'hh:mm a').diff(moment(b, 'hh:mm a'))));
        emit({ data: timeSlots, type: 'time_slots' });
      }
      if (Array.isArray(props.data.league_divisions)) {
        setDivision(props.data.league_divisions);
      }
    }
    //eslint-disable-next-line
  }, [props.data]);

  const popupHandler = (event, type) => {
    event.preventDefault();
    loadModalContent(type);
    setOpen(o => !o);
  }

  const emit = (e) => {
    if (props.onChange) {
      props.onChange(e)
    }
  }

  const handleModalCloseResponse = (resp) => {
    if (resp) {
      switch (resp.type) {
        case 'location':
          setLocationsAndFields(resp.data);
          break;
        case 'time_slots':
          setTimeSlots(resp.data);
          break;
        case 'days_played':
          setDaysPlayed(resp.data);
          break;
        default:
          break;
      }
      emit(resp);
    }
    setOpen(false);
  }

  const loadModalContent = (type) => {
    setType(type);
    const modal = {
      location: (
        <LocationModal
          closeModal={handleModalCloseResponse}
          selectedData={locationsAndFields && Array.isArray(locationsAndFields) ? locationsAndFields : []}
        />
      ),
      time_slots: <TimeModal closeModal={handleModalCloseResponse} selectedData={timeSlots && Array.isArray(timeSlots) ? timeSlots : []} />,
      days_played: (() => {
        let list = _.cloneDeep(days_played);
        if (daysPlayed && Array.isArray(daysPlayed)) {
          list = list.map(day => {
            const obj = daysPlayed.find(selDay => selDay.day === day);
            if (obj) {
              return {
                checked: true,
                indv_reg_allow: obj.indv_reg_allow,
                day,
              }
            } else {
              return {
                checked: false,
                indv_reg_allow: false,
                day,
              }
            }
          });
        }
        return <DaysModal data={list} closeModal={handleModalCloseResponse} />
      })(),
      division_name: <DivisionName closeModal={handleModalCloseResponse}
      selectedData={leagueDivision && Array.isArray(leagueDivision) ? leagueDivision : []}></DivisionName> ,
    }
    setModalContent(modal[type]);
  }

  return (
    <>
      <div className="input-blk input-field">
        <span className="label">Locations and Fields</span>
        {locationsAndFields && locationsAndFields?.length ? 
          <div className="location-wrapper">
            {
              locationsAndFields.map((loc, index) => (
                <div className="location-blk" key={`location-key-${index + 1}`}>
                  <h3>{loc?.location?.title}</h3>
                  <ul>
                    {
                      Array.isArray(loc.fields) &&
                      loc.fields.map((field, idx) => <li key={`location-fields-${index + 1}-${idx + 1}`}>{field?.title}</li>)
                    }
                  </ul>
                </div>
              ))
            }
          </div>: ''
        }
        <button className="btn" onClick={(e) => popupHandler(e, 'location')}>Edit Locations and Fields</button>
        {!locationsAndFields.length && props.formSubmitted && <span className="error">{messages.locationField_error}</span>}
      </div>
      <div className="input-blk input-field">
        <span className="label">Time Slots</span>
        {
          Array.isArray(timeSlots) &&
          timeSlots.length > 0 &&
          <div className="location-wrapper">
            <div className="location-blk">
              <ul>
                {timeSlots.map((time, i) => <li key={i}>{time}</li>)}
              </ul>
            </div>
          </div>
        }
        <button className="btn" onClick={(e) => popupHandler(e, 'time_slots')}>Edit Time Slots</button>
        {!timeSlots.length && props.formSubmitted && <span className="error">{messages.timeSlot_error}</span>}
      </div>
      <div className="input-blk input-field">
        <span className="label">Days Played</span>
        {
          Array.isArray(daysPlayed) &&
          daysPlayed.length > 0 &&
          <div className="location-wrapper">
            <div className="location-blk">
              <ul>
                {daysPlayed.map((d, i) => <li key={i}>{d.day}</li>)}
              </ul>
            </div>
          </div>
        }
        <button className="btn" onClick={(e) => popupHandler(e, 'days_played')}>Edit Days Played</button>
        {!daysPlayed.length && props.formSubmitted && <span className="error">{messages.daysPlayed_error}</span>}
      </div>
      <div className="input-blk input-field">
        <span className="label">Division Name</span>
        {
          Array.isArray(leagueDivision) &&
          leagueDivision.length > 0 &&
          <div className="location-wrapper">
            <div className="location-blk">
              <ul>
                {leagueDivision.map((d, i) => <li key={i}>{d.name}</li>)}
              </ul>
            </div>
          </div>
        }
        <button className="btn" onClick={(e) => popupHandler(e, 'division_name')}>Edit Division Name</button>
      </div>
      <Popup className={type === 'time_slots' ? 'overflow-container' : ''} closeOnDocumentClick={false} open={open}>
        {modalContent}
      </Popup>
    </>
  );
}